<template>
  <!-- exhibition-product .ep -->
  <div class="ecb">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>My Cloud Booth</BreadcrumbItem>
          <BreadcrumbItem to="/exhibitionEn/index/product/allpro">Upload Products</BreadcrumbItem>
          <BreadcrumbItem>Edit Product</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.nameEn}}</div>
      </div>
      <div class="f-tar" style="padding-top: 37px;">
        <Button @click="$router.push('/exhibitionEn/index/product/allpro')">Back</Button>
      </div>
    </div>
    <div class="editpro">
      <div class="editpro-box">
        <Form ref="form" :model="form" :label-width="220" :rules="ruleValidate">
          <FormItem label="Product display list:">
            <Select v-model="form.GroupInfo" multiple style="width:400px" placeholder="Product display list">
              <template v-if="list && list.items && list.items.length">
                <Option v-for="item in list.items" :value="item.id" :key="item.id">{{ item.name }}</Option>
              </template>
            </Select>
          </FormItem>
          <FormItem label="Investment promotion region:" prop="zhaoShangRegion" :required="true">
            <!-- {{form.zhaoShangRegion}} -->
            <Row
              v-for="(item, index) in form.zhaoShangRegion"
              :key="'cityInfo-' + index"
              style="width: 400px;margin-bottom: 5px;"
            >
              <Col span="22">
                <Cascader
                  v-model="form.zhaoShangRegion[index]"
                  filterable
                  placeholder="Investment promotion region"
                  :data="countryList"
                  :load-data="changeZhaoShangRegion"
                  :key="'zhaoShangRegionArr-' + index"
                ></Cascader>
              </Col>
              <Col span="2" class="ie-icon" style="text-align:center;">
                <Icon
                  type="ios-add-circle-outline"
                  v-if="index === 0"
                  @click="addCityArr()"
                  style="color: #2d8cf0;font-size: 20px;cursor: pointer;"
                />
                <Icon
                  type="ios-remove-circle-outline"
                  v-else
                  style="color: red;font-size: 20px;cursor: pointer;"
                  @click="delCityArr(index)"
                />
              </Col>
            </Row>
            <p class="pro-tip">To increase the promotion effect of your product, please add product region</p>
          </FormItem>
          <FormItem label="Product category:" prop="category" :required="true">
            <Cascader
              v-model="form.category"
              :data="type"
              filterable
              style="width: 400px;"
              @on-change="changeCategory();validSingle('form', 'category')"
              placeholder="Product category"
            ></Cascader>
            <p class="pro-tip">To increase the promotion effect of your product, please add product category</p>
          </FormItem>

          <FormItem label="Product label:" prop="tag" :required="true">
             <Row
              v-for="(item, index) in form.Protag"
              :key="'proInfo-' + index"
              style="width: 400px; margin-bottom: 5px"
            >
              <Col span="23">
                <Cascader
                  v-model="form.Protag[index]"
                  :value="form.Protag[index]"
                  :data="ProTagList"
                  filterable
                  :key="'Protag-' + index"
                  placeholder="Product label"
                ></Cascader>
              </Col>
              <Col span="1" class="ie-icon" style="text-align: center">
                <Icon
                  type="ios-add-circle-outline"
                  v-if="index === 0"
                  @click="addProductTag()"
                  style="color: #2d8cf0; font-size: 20px; cursor: pointer"
                />
                <Icon
                  type="ios-remove-circle-outline"
                  v-else
                  style="color: red; font-size: 20px; cursor: pointer"
                  @click="delProductTag(index)"
                />
              </Col>
            </Row>
            <p class="pro-tip">To increase the promotion effect of your product, please add product label</p>
          </FormItem>

          <FormItem label="Product applicable channels:" prop="proChannel" :required="true">
            <Select v-model="form.proChannel" multiple style="width: 400px;" placeholder="Product applicable channels">
              <Option v-for="(item,index) in proChannels" :value="item.name" :key="index">{{ item.nameEn }}</Option>
            </Select>
          </FormItem>
          <FormItem label="Product applicable department:" prop="proOffice" :required="true">
            <Select v-model="form.proOffice" multiple style="width: 400px;" placeholder="Product applicable department">
              <Option v-for="(item,index) in proOffices" :value="item.name" :key="index">{{ item.nameEn }}</Option>
            </Select>
          </FormItem>
          <FormItem label="Product certification:" :required="true">
            <authSelect v-model="form.Authentication" ref="authSelect" @auth="setAuthTxt"></authSelect>
            <div
              class="ivu-form-item-error-tip"
              v-if="validOpen && authSelectValid"
            >{{authSelectValid}}</div>
            <p class="pro-tip">To increase the promotion effect of your product, please add product certification</p>
          </FormItem>
          <FormItem label="Quality system of certification:">
            <authSelect v-model="form.CertificateQualities" :type="2" ref="qualitiesSelect" @auth="setAuthTxt2"></authSelect>
            <div
              class="ivu-form-item-error-tip"
              v-if="validOpen2 && qualitiesSelectValid"
            >{{qualitiesSelectValid}}</div>
          </FormItem>
          <FormItem label="Product name:" prop="name">
            <Input v-model="form.name" placeholder="Product name" style="width: 400px"></Input>
          </FormItem>
          <FormItem label="Product picture:" prop="proImg">
            <div>
              <upload ref="upload1" :fileList="uploadBanner" :config="uploadBannerConfig" @upload-ok="bannerOK" />
            </div>
          </FormItem>
          <FormItem label="Cover Video:" prop="proVideo">
            <div>
              <upload
                :config="uploadVideoConfig"
                @upload-ok="videoOK"
                :fileList="uploadVideo"
                class="upload-1"
                ref="upload2"
              />
            </div>
          </FormItem>
          <!-- <FormItem>
            <Checkbox size="large" v-model="form.apply" @on-change="changeApply()">
              <span style="display: inline-block;width: 10px;"></span>开启体验
            </Checkbox>
          </FormItem>-->
          <FormItem label="体验名额:" v-show="form.apply">
            <InputNumber
              v-model="form.applyMaxCount"
              :min="0"
              style="width:100px;margin-right:10px;"
            ></InputNumber>人
            <span style="font-size:12px;margin-left:10px;">(0表示不限量)</span>
          </FormItem>
          <FormItem label="报名时间:" prop="date" v-show="form.apply">
            <DatePicker
              type="datetimerange"
              format="yyyy-MM-dd HH:mm"
              placeholder="请选择报名时间"
              style="width: 300px;"
              v-model="applyDate"
            ></DatePicker>
          </FormItem>
          <!-- <FormItem>
            <Checkbox size="large" v-model="form.showPrice" @on-change="changePrice()">
              <span style="display: inline-block;width: 10px;"></span>显示价格
            </Checkbox>
          </FormItem>
          <FormItem label="价格:" v-show="form.showPrice" style="display:inline-block">
            <InputNumber
              v-model="form.price"
              placeholder="0"
              :min="0"
              style="width:100px;margin-right:10px;"
            ></InputNumber>元
          </FormItem>
          <FormItem label="划线价格:" v-show="form.showPrice" style="display:inline-block">
            <InputNumber
              v-model="form.linePrice"
              placeholder="0"
              :min="0"
              style="width:100px;margin-right:10px;"
            ></InputNumber>元
          </FormItem> -->
          <FormItem>
            <Checkbox size="large" v-model="form.isShow">
              <span style="display: inline-block;width: 10px;"></span>Display
            </Checkbox>
          </FormItem>
          <FormItem label="Display order:">
            <InputNumber v-model="form.showIndex" :min="0" style="width:100px;margin-right:10px;"></InputNumber>
          </FormItem>
          
          <FormItem label="Product Introduction:">
            <Input type="textarea" style="width:400px;" v-model="form.intro" :rows="6" placeholder="Product Introduction"></Input>
          </FormItem>

          <!-- <FormItem label="招商区域:" prop="zhaoShangRegion" :required="true">
            <Cascader
              v-model="form.zhaoShangRegion"
              :data="provinces"
              filterable
              style="width: 400px;"
              @on-change="validSingle('form', 'zhaoShangRegion')"
            ></Cascader>
          </FormItem>-->

          <FormItem label="Product Details:" class="ivu-form-item-required">
            <div class="no-padding">
              <customComponentCommon v-model="Introduction" :type="commonType" @change="changModal"></customComponentCommon>
            </div>
          </FormItem>
        </Form>
        <div style="width:100%;padding-left:220px;">
          <Button
            type="primary"
            @click="handleSubmit('form',0)"
            style="width:140px;height:35px;font-size:14px"
            :loading="initLoading"
          >Save</Button>
          <Button
            type="primary"
            @click="handleSubmit('form',1)"
            style="width:140px;height:35px;font-size:14px;margin-left:20px;"
            :loading="initLoading"
          >Save and Preview</Button>
        </div>
      </div>
    </div>

    <Contact />
  </div>
</template>

<script>
import { provinces } from "@/other/provinces";
import Contact from "@components/En/Contact/Contact";
import upload from "@components/En/upLoad/upLoad";
import { mapGetters, mapActions } from "vuex";
import customComponentCommon from "@components/En/custom-component/custom-component-common.vue";
import authSelect from "@components/En/auth-select/auth-select.vue";

export default {
  name: "exhibition-product-edit",
  data() {
    const validateProImg = (rule, value, callback) => {
      if (this.uploadBanner && this.uploadBanner.length) {
        callback();
      } else {
        callback(new Error("Product picture cannot be empty"));
      }
    };
    const proApply = (rule, value, callback) => {
      if (this.form.apply) {
        if (this.applyDate[1]) {
          callback();
        } else {
          callback(new Error("请选择体验报名时间"));
        }
      } else {
        callback();
      }
    };
    const zhaoShangRegionValid = (rule, value, callback) => {
      if (value && value[0] && value[0].length) {
        callback();
      } else {
        callback(new Error("Please select investment promotion region"));
      }
    };
    const categoryValid = (rule, value, callback) => {
      if (value && value.length) {
        callback();
      } else {
        callback(new Error("Please select product category"));
      }
    };
    const tagValid = (rule, value, callback) => {
      if (JSON.stringify(this.TagData)) {
        callback();
      } else {
        callback(new Error("Please select the product label"));
      }
    };
    const channelValid = (rule, value, callback) => {
      if (value && value.length) {
        callback();
      } else {
        callback(new Error("Please select the product applicable channel"));
      }
    };
    const officeValid = (rule, value, callback) => {
      if (value && value.length) {
        callback();
      } else {
        callback(new Error("Please select the product applicable department"));
      }
    };
    return {
      commonType: 2, //
      list: null,
      pageSize: 16,
      pageIndex: 1,
      totalCount: 0,
      countryList: [],

      editData: "",
      Introduction: [], // 产品详情

      uploadBanner: [], // 产品图
      uploadVideo: [], // 主图视频
      applyDate: [], // 体验报名时间
      config: {
        fileType: "img",
        headers: {},
        action: "",
        format: ["jpg", "jpeg", "png"],
        "max-size": 2048,
        remind:
          "(Requirements: .jpg/png within 2M, suggested size is 900*600px, up to 15 pictures)",
        limitNum: 15
      },
      form: {
        name: "", // 产品名称
        apply: false, // 是否开启体验
        applyMaxCount: 0, // 体验名额
        showPrice: true, // 是否显示价格
        showIndex: 0, // 显示顺序
        price: 0, // 价格
        linePrice: 0, // 划线价格
        isShow: true, // 是否显示
        GroupInfo: "", // 分组信息
        category: [], // 展品分类
        tag: [], // 展品标签

        zhaoShangRegion: [[]],
        Protag: [[]],
        Authentication: [],
        proChannel: [], // 产品适用渠道
        proOffice: [], // 产品应用科室
        CertificateQualities: [], // 质量体系认证
        intro: ""
      },
      authSelectValid: "", // 产品认证的信息
      qualitiesSelectValid: "", // 质量体系认证的信息
      ruleValidate: {
        name: [
          { required: true, message: "Product name cannot be empty", trigger: "blur" }
        ],
        zhaoShangRegion: [
          {
            validator: zhaoShangRegionValid,
            trigger: "change"
          }
        ],
        category: [
          {
            validator: categoryValid,
            trigger: "change"
          }
        ],
        tag: [
          {
            validator: tagValid,
            trigger: "change"
          }
        ],
        proImg: [
          { required: true, validator: validateProImg, trigger: "change" }
        ],
        date: [{ required: true, validator: proApply, trigger: "change" }],
        proChannel: [
          {
            validator: channelValid,
            trigger: "change"
          },
          {
            validator: channelValid,
            trigger: "blur"
          }
        ],
        proOffice: [
          {
            validator: officeValid,
            trigger: "change"
          },
          {
            validator: officeValid,
            trigger: "blur"
          }
        ],
      },
      videoList: [], // 视频详情

      provinces: provinces.data,
      ProTagList: [], // 产品标签
      ProAuthList: [], // 产品认证
      type: [],
      type2: [],
      validOpen: false,
      validOpen2: false,

      CategoryData: null,
      TagData: null,
      proChannels: [], // 产品适用渠道列表
      proOffices: [], // 产品应用科室列表
      initLoading: false, // 初始化类目请求
      arr: [],
    };
  },
  computed: {
    uploadBannerConfig() {
      let config = JSON.parse(JSON.stringify(this.config));
      config.id = "upload_1";
      config.headers = this.formHeaders;
      config.action = this.uploadUrl;
      return config;
    },
    uploadVideoConfig() {
      let config = JSON.parse(JSON.stringify(this.config));
      config.id = "upload_2";
      config.fileType = "video";
      config.headers = this.formHeaders;
      config.action = this.uploadVideoUrl;
      config.format = ["mp4"];
      config["max-size"] = 51200; // 50M
      config.limitNum = 1;
      config.remind =
        "(Requirement: within 50M, suggested length is 9-30s, image scale is 16:9)";
      return config;
    },
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      uploadVideoUrl: "getUploadVideoUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    }),
    query() {
      return this.$router.history.current.query;
    },
    option() {
      return { compId: this.company.id, pageSize: 1000 };
    }
  },
  created() {
    this.init();
  },
  destroyed() {
    // console.log("销毁定时器");
    this.$Message.destroy();
  },
  methods: {
    ...mapActions({
      getProductGroup: "productModule/getProductGroup",
      getProductById: "productModule/getProductById",
      editProduct: "productModule/editProduct",

      getRegionList: "exhibitionModule/getRegionList",
      getProChannels: "exhibitionModule/getProChannels",
      getProOffices: "exhibitionModule/getProOffices",
      getCountryList: "exhibitionModule/getCountryList",
      getCityByParentId: "exhibitionModule/getCityByParentId",

      transformCustomData: "customComponentModule/transformCustomData",
      transformReqCustomData: "customComponentModule/transformReqCustomData",

      getProductByGroupId: "categoryModule/getProductByGroupId", // 根据展会Id获取产品类别

      getProTag: "companyInfoModule/getProTag", // 获取产品标签
      getProAuth: "companyInfoModule/getProAuth" // 获取产品认证
    }),
    setAuthTxt(txt) {
      this.authSelectValid = txt;
      if (txt) this.validOpen = true;
    },
    setAuthTxt2(txt) {
      this.qualitiesSelectValid = txt;
      if (txt) this.validOpen2 = true;
    },
    async init() {
      this.initLoading = true;
      const msg = this.$Message.loading({
        content: 'Loading...',
        duration: 0
      });
      let listData = await this.getProductGroup(this.option);

      if (listData && listData.items) {
        listData.items.forEach(c => {
          c.introduction = JSON.parse(c.introduction);
        });
        this.list = listData;
        this.pageSize = this.list.pageSize;
        this.pageIndex = this.list.pageIndex;
        this.totalCount = this.list.totalCount;
      }

      if (!this.query.id) return;
      this.editData = await this.getProductById(this.query.id);
      console.log("详情信息：",this.editData);
      this.form.name = this.editData.name;
      if (JSON.parse(this.editData.banner)) {
        this.uploadBanner = JSON.parse(this.editData.banner);
      }
      if (JSON.parse(this.editData.video).Link) {
        this.uploadVideo = [
          {
            url: JSON.parse(this.editData.video).Link,
            src: JSON.parse(this.editData.video).Img
          }
        ];
      }
      if (this.editData.applicableChannels) {
        this.editData.applicableChannels = JSON.parse(this.editData.applicableChannels);
        this.form.proChannel = this.editData.applicableChannels;
      }
      if (this.editData.appliedSectionOffices) {
        this.editData.appliedSectionOffices = JSON.parse(this.editData.appliedSectionOffices);
        this.form.proOffice = this.editData.appliedSectionOffices;
      }
      this.form.apply = this.editData.isApply;
      this.form.applyMaxCount = this.editData.applyMaxCount;
      if (this.editData.applyStart && this.editData.applyEnd) {
        this.applyDate = [this.editData.applyStart, this.editData.applyEnd];
      }
      // if (this.editData.price !== 0 || this.editData.linePrice !== 0) {
      //   this.form.showPrice = true;
      //   this.form.price = this.editData.price;
      //   this.form.linePrice = this.editData.linePrice;
      // } else {
      //   this.form.showPrice = false;
      // }
      this.form.isShow = this.editData.isShow;
      this.form.showIndex = this.editData.showIndex;
      this.form.intro = this.editData.intro;
      if (
        this.editData.category &&
        this.editData.category.indexOf("{") !== -1
      ) {
        const category = JSON.parse(this.editData.category);
        const categoryArr = [];
        if (category.Id) {
          categoryArr.push(category.Id);
          if (category.List) {
            if (category.List[0]) {
              categoryArr.push(category.List[0].Id);
              if (category.List[0].List) {
                categoryArr.push(category.List[0].List[0].Id);
              }
            }
          }
        }
        this.form.category = categoryArr;
      }
      // if (this.editData.tag && this.editData.tag.indexOf("{") !== -1) {
      //   const tag = JSON.parse(this.editData.tag);
      //   const tagArr = [];
      //   if (tag.Id) {
      //     tagArr.push(tag.Id);
      //     if (tag.List) {
      //       if (tag.List[0]) {
      //         tagArr.push(tag.List[0].Id);
      //         if (tag.List[0].List) {
      //           tagArr.push(tag.List[0].List[0].Id);
      //         }
      //       }
      //     }
      //   }
      //   this.form.tag = tagArr;
      // }
      if (this.editData.tag) {
        //console.log(this.editData.tag,' this.form.Protag');
        let arr = JSON.parse(this.editData.tag);
        const tagArr = [];
        arr.forEach((e) => {
          tagArr.push([]);
        });

        this.form.Protag.push(JSON.parse(this.editData.tag));
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].Id) {
            console.log(tagArr[i], "id");
            tagArr[i].push(arr[i].Id);
            if (arr[i].List) {
              if (arr[i].List[0]) {
                tagArr[i].push(arr[i].List[0].Id);
                if (arr[i].List[0].List) {
                  tagArr[i].push(arr[i].List[0].List[0].Id);
                }
              }
            }
          }
        }
        this.form.Protag = tagArr;
        console.log(tagArr, "  this.form.Protag");
      }
      if (
        this.editData.authentication &&
        this.editData.authentication.indexOf("[") !== -1
      ) {
        this.form.Authentication = JSON.parse(this.editData.authentication);
      }
      if (
        this.editData.certificateQualities &&
        this.editData.certificateQualities.indexOf("[") !== -1
      ) {
        this.form.CertificateQualities = JSON.parse(this.editData.certificateQualities);
      }
      if (
        this.editData.introduction &&
        this.editData.introduction.indexOf("[") !== -1
      ) {
        this.Introduction = await this.transformCustomData(
          JSON.parse(this.editData.introduction)
        );
      }
      if (
        this.editData.groupInfo &&
        this.editData.groupInfo.indexOf("[") !== -1
      ) {
        this.editData.groupInfo = JSON.parse(this.editData.groupInfo);
        let arr = [];
        this.editData.groupInfo.forEach(c => {
          arr.push(c.Id);
        });
        this.form.GroupInfo = arr;
      }

      this.ProAuthList = await this.getProAuth();

      let ProTagData = await this.getProTag();
      if (ProTagData && ProTagData.length) {
        ProTagData.map(c => {
          c.value = c.id;
          c.label = c.nameEn;
          c.children = JSON.parse(JSON.stringify(c.list));
          c.children.map(v => {
            v.value = v.id;
            v.label = v.nameEn;
            v.children = JSON.parse(JSON.stringify(v.list));
            v.children.map(z => {
              z.value = z.id;
              z.label = z.nameEn;
              z.children = JSON.parse(JSON.stringify(z.list));
            });
          });
        });
        this.ProTagList = ProTagData;
      } else {
        this.ProTagList = [];
      }

      let categoryData = await this.getProductByGroupId({
        groupId: this.exhibition.groupId,
        level: 0,
        loadChild: true,
      }); // 暂时先写死了值
      if (categoryData && categoryData.length) {
        categoryData.map(c => {
          c.value = c.id;
          c.label = c.nameEn;
          c.children = JSON.parse(JSON.stringify(c.list));
          c.children.map(v => {
            v.value = v.id;
            v.label = v.nameEn;
            v.children = JSON.parse(JSON.stringify(v.list));
            v.children.map(z => {
              z.value = z.id;
              z.label = z.nameEn;
              z.children = JSON.parse(JSON.stringify(z.list));
            });
          });
        });
        this.type = categoryData;
      } else {
        this.type = [];
      }
      // let countryList = await this.getCountryList();
      // if (countryList && countryList.length > 0) {
      //   countryList.map(c => {
      //     c.value = c.name;
      //     c.label = c.name;
      //     if (c.name === "中国") {
      //       c.loading = false;
      //       c.children = [];
      //     }
      //   });
      //   this.countryList = countryList;
      // }
      let regionList  = await this.getRegionList();
      if (regionList && regionList.length > 0) {
        regionList.map(c => {
          c.value = c.name;
          c.label = c.nameEn;
          c.children = c.list;
          if (c.children && c.children.length > 0) {
            c.children.map(d => {
              d.value = d.name;
              d.label = d.nameEn;
              d.children = d.list;
              if (d.children && d.children.length > 0) [
                d.children.map(e => {
                  e.value = e.name;
                  e.label = e.nameEn;
                })
              ]
            })
          }
        })
        this.countryList = regionList;
      }

      // this.form.zhaoShangRegion = [["中国", "北京", "北京市"]];
      let proChannels = await this.getProChannels();
      if (proChannels && proChannels.length > 0) {
        this.proChannels = proChannels;
      }

      let proOffices = await this.getProOffices();
      if (proOffices && proOffices.length > 0) {
        this.proOffices = proOffices;
      }

      setTimeout(()=> { 
        if (
          this.editData.zhaoShangRegion &&
          this.editData.zhaoShangRegion.indexOf("[") !== -1
        ) {
          this.form.zhaoShangRegion = JSON.parse(this.editData.zhaoShangRegion); 
        }
        if (!this.form.zhaoShangRegion) {
          this.form.zhaoShangRegion = [[]];
        } 
      }, 200);
      
      // 类目加载完毕，可保存
      msg();
      this.initLoading = false;
    },
    bannerOK(list) {
      this.uploadBanner = list;
    },
    videoOK(list) {
      this.uploadVideo = list;
    },
    changeApply() {
      if (this.form.apply === false) {
        this.applyDate = [];
        this.form.applyMaxCount = 0;
      }
    },
    changePrice() {
      if (this.form.showPrice === false) {
        this.form.price = 0;
        this.form.linePrice = 0;
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    async handleSubmit(name,e) {
      let txt = "";
      this.arr=[]
      this.TagData = Array.from(new Set(this.changeTag(this.form.Protag)));
      this.CategoryData = this.changeCategory();
      this.validOpen = true;
      let valid = await this.validForm(name);
      this.$refs[name].fields.forEach(c => {
        if (txt) return;
        if (c.validateState === "error") {
          txt = c.validateMessage;
        }
      });
      if (!valid && txt) {
        this.$Message.warning(txt);
      }
      if (!valid) return;
      if (this.authSelectValid) {
        this.$Message.warning(this.authSelectValid);
        return;
      }
      let authData = this.changeAuth();
      let qualitiesData = this.changeQualties();
      // 主图视频
      let video = {
        cover: 0,
        Time: 200,
        Img: "",
        Link: ""
      };
      if (this.uploadVideo.length > 0) {
        video.Link = this.uploadVideo[0].url;
        video.Img = this.uploadVideo[0].src;
      }
      // 体验报名时间、人数
      let ApplyStart = "";
      let ApplyEnd = "";
      let ApplyMaxCount = 0;
      if (this.form.apply && this.applyDate.length > 0) {
        ApplyStart = this.applyDate[0];
        ApplyEnd = this.applyDate[1];
        ApplyMaxCount = this.form.applyMaxCount;
      } else {
        this.form.apply = false;
      }
      let canApply = "";
      if (new Date(this.applyDate[1]).getTime() > new Date().getTime()) {
        canApply = 1;
      } else {
        canApply = 0;
      }
      // 是否显示价格
      // if (
      //   this.form.showPrice === true &&
      //   this.form.price === 0 &&
      //   this.form.linePrice === 0
      // ) {
      //   this.$Message.error("请输入价格和划线价格");
      //   return;
      // }

      // 产品详情
      let Introduction = await this.transformReqCustomData(this.Introduction);
      if (!Introduction || Introduction === "[]") {
        this.$Message.error("Please complete the details");
        return;
      }
      let GroupInfo = [];
      if (this.form.GroupInfo.length) {
        this.list.items.forEach(c => {
          if (this.form.GroupInfo.indexOf(c.id) !== -1) {
            GroupInfo.push({ Id: c.id, Name: c.name });
          }
        });
      }

      let form = {
        Id: this.editData.id,
        SetValues: {
          Name: this.form.name,
          Banner: this.uploadBanner,
          CompId: this.company.id,
          AgentId: this.company.agentId,
          IsApply: this.form.apply,
          CanApply: canApply, // 控制小程序是否显示体验报名时间
          ApplyMaxCount: ApplyMaxCount,
          ApplyStart: ApplyStart,
          ApplyEnd: ApplyEnd,
          // Price: this.form.price,
          // LinePrice: this.form.linePrice,
          IsShow: this.form.isShow,
          ShowIndex: this.form.showIndex,
          Video: video,
          GroupInfo: GroupInfo,
          Introduction: Introduction,
          Authentication: authData,
          Tag: this.TagData,
          ZhaoShangRegion: this.form.zhaoShangRegion,
          Category: this.CategoryData,
          ApplicableChannels: this.form.proChannel,
          AppliedSectionOffices: this.form.proOffice,
          CertificateQualities: qualitiesData,
          Intro: this.form.intro
        }
      };
      let bool = await this.editProduct(form);
      if (bool.successed) {
        this.$Message.success("successful");
        if (e === 0) {
          this.$router.push("/exhibitionEn/index/product/allpro");
        }
        if (e === 1) {
          this.$router.push("/exhibitionEn/index/template");
        }
      } else {
        this.$Message.error("fail,please try again");
      }
    },

    changModal($event) {
      this.Introduction = $event;
    },
    changeCategory() {
      let category = this.form.category;
      let data = null;
      this.type.forEach(c => {
        if (category[0] && c.id === category[0]) {
          data = {
            Id: c.id,
            Value: c.name,
            List: []
          };
          if (c.list && c.list.length && category[1]) {
            c.list.forEach(v => {
              if (v.id === category[1]) {
                data.List[0] = {
                  Id: v.id,
                  Value: v.name
                };
                if (v.list && v.list.length && category[2]) {
                  v.list.forEach(j => {
                    if (j.id === category[2]) {
                      data.List[0].list = [
                        {
                          Id: j.id,
                          Value: j.name,
                          Remark: j.tag
                        }
                      ];
                    }
                  });
                }
              }
            });
          }
        }
      });
      return data;
    },
    changeTag(Protag) {
      //let tag = this.form.tag;
      //标签数组
      console.log(Protag[0].length);
      let tag = Protag;
      if (Protag[0].length == 0) {
        return;
      }
      let data = null;
      tag.forEach((e) => {
        this.ProTagList.forEach((c) => {
          if (e[0] && c.id === e[0]) {
            data = {
              Id: c.id,
              Value: c.name,
              List: [],
            };
            if (c.list && c.list.length && e[1]) {
              c.list.forEach((v) => {
                if (v.id === e[1]) {
                  data.List = [
                    {
                      Id: v.id,
                      Value: v.name,
                    },
                  ];
                  if (v.list && v.list.length && e[2]) {
                    v.list.forEach((j) => {
                      if (j.id === e[2]) {
                        data.List[0].list = [
                          {
                            Id: j.id,
                            Value: j.name,
                          },
                        ];
                      }
                    });
                  }
                }
              });
            }
          }
        });

        this.arr.push(data);
      });

      return this.arr;
    },
    changeAuth() {
      let auth = this.form.Authentication;
      let arr = [];
      auth.forEach(c => {
        if (c.FilePath) {
          arr.push(c);
        }
      });
      return arr;
    },
    changeQualties() {
      let auth = this.form.CertificateQualities;
      let arr = [];
      auth.forEach(c => {
        if (c.FilePath) {
          arr.push(c);
        }
      });
      return arr;
    },
    async changeZhaoShangRegion(item, callback) {
      let data = await this.getCityByParentId(item.id);
      item.loading = true;
      if (data && data.length > 0) {
        data.map(c => {
          if (c.leveltype !== 2) {
            c.loading = false;
            c.children = [];
          }
          c.value = c.name;
          c.label = c.name;
          c.type = item.type + 1;
        });
        item.children = data;
      } else {
        item.children = null;
      }
      item.loading = false;
      callback();
    },
    addCityArr() {
      this.form.zhaoShangRegion.push([]);
    },
    delCityArr(i) {
      this.form.zhaoShangRegion.splice(i, 1);
    },
    addProductTag() {
      this.form.Protag.push([]);
    },
    delProductTag(i) {
      this.form.Protag.splice(i, 1);
    },
  },
  components: {
    Contact,
    upload,
    customComponentCommon,
    authSelect
  }
  // mounted() {
  //   this.init();
  // }
};
</script>

<style lang="scss">
.editpro {
  .ivu-modal-header {
    border-bottom: none;
    padding: 14px 0;
  }
}
</style>
<style scoped lang="scss">
.ecb {
  .editpro {
    background-color: #fff;
    margin: 30px;
    min-width: 800px;
    &-box {
      padding: 20px 85px 40px 50px;
    }
  }
  .text-box {
    width: 375px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    border: dashed 1px rgba(191, 191, 191, 0.5);
    border-radius: 5px;
    cursor: pointer;
    &:hover {
      border: dashed 1px rgba(23, 143, 255, 1);
    }
  }

  .c-1 {
    &:hover {
      background-color: #f2f2f2;
    }
  }
  .c-2 {
    &:hover {
      background-color: #f2f2f2;
    }
  }
  .c-3 {
    &:hover {
      background-color: #f2f2f2;
    }
  }
}
.v-center {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 500;
  }
}
.pro-tip {
  line-height: 1;
  color: #333;
  padding-top: 6px;
}
</style>
